import blockImageField from './blockImageField';

export default {
  ...blockImageField,
  width: 750,
  height: 300
};
